import { render, staticRenderFns } from "./swap-forum.vue?vue&type=template&id=bbda0424"
import script from "./swap-forum.vue?vue&type=script&lang=ts"
export * from "./swap-forum.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports